module.exports = __webpack_public_path__ + "staticcomp/img/top.4bc3488.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/8/top.jpg
// module id = RU4+
// module chunks = 39